import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';
import { Paper, Typography, Grid, Input, Tooltip } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import WarningIcon from '@material-ui/icons/ErrorOutline';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import NotesIcon from '@material-ui/icons/Notes';
import { ReactComponent as UploadFileIcon } from '../../../assets/images/upload_file.svg';
import { fetchAccountNotes } from '../../../redux/reducers/AccountNotes';

const useStyles = makeStyles((theme) => ({
  accordionSummaryCollapsed: {
    '&&': {
      borderBottomLeftRadius: '5px',
      borderBottomRightRadius: '5px',
      padding: '10px',
      display: 'flex',
      paddingLeft: '15px',
      paddingRight: '15px',
    },
  },
  paperItemsCollapsed: {
    '&&': {
      border: '1px solid #CFD4DB',
      width: '100%',
      borderBottom: '1px solid #CFD4DB',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '10px',
      marginRight: '5px',
      marginLeft: '5px',
      borderRadius: '12px',
      height: '70px',
    },
  },
  paperItemsCollapsedDragged: {
    '&&': {
      border: '2px dashed #1E88E5',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      // justifyContent: 'space-between',
      // padding: '10px',
      marginRight: '5px',
      marginLeft: '5px',
      borderRadius: '12px',
      height: '70px',

      fontFamily: '"articulat-cf", sans-serif !important',
      justifyContent: 'center',
      padding: theme.spacing(2),
      cursor: 'pointer',
      gap: theme.spacing(1),
      fontSize: '13px',
      fontWeight: 600,
      lineHeight: '22px',
      letterSpacing: '0.02em',
      textAlign: 'center',
      padding: '24px 16px',
      gap: '8px',
      backgroundColor: '#e3f2fd'
    },
  },
  paperItemsExpanded: {
    '&&': {
      border: '1px solid #CFD4DB',
      width: '100%',
      borderBottom: '1px solid #CFD4DB',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '10px',
      marginRight: '5px',
      marginLeft: '5px',
      borderRadius: '12px',
      height: '160px',
    },
  },
  header: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingTop: '10px',
  },
  titleTabs: {
    '&&': {
      fontFamily: '"articulat-cf", sans-serif !important',
      color: '#3B4149',
      fontSize: '16px',
      fontWeight: 700,
      fontStyle: 'normal',
      lineHeight: 'normal',
    },
  },
  body: {
    width: '100%',
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingBottom: '10px',
  },
  list: {
    width: '100%',
    padding: 0,
  },
  listItemTextFont: {
    "&&": {
      fontFamily: '"articulat-cf", sans-serif !important',
      color: '#3B4149',
      fontStyle: 'normal',
      maxWidth: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: '15px',
      fontWeight: 600,
      lineHeight: '20px',
      letterSpacing: '0.03em',
      textAlign: 'left',
    }
  },
  container: {
    padding: '10px',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  warningIcon: {
    '&&': {
      color: '#BA1A1A !important',
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '22.08px',
      textAlign: 'right',
    },
  },
  addCircleOutlineIcon: {
    '&&': {
      color: '#3B4149',
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '22.08px',
      textAlign: 'right',
    },
  },
  uploadArea: {
    '&&': {
      fontFamily: '"articulat-cf", sans-serif !important',
      border: '2px dashed #C5CBD499 !important',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(2),
      cursor: 'pointer',
      width: '100%',
      gap: theme.spacing(1),
      fontSize: '13px',
      fontWeight: 600,
      lineHeight: '22px',
      letterSpacing: '0.02em',
      marginTop: '10px',
      '&.dragover': {
        backgroundColor: '#e3f2fd', 
        borderColor: '#42a5f5', 
      },
    },
  },
  uploadAreaSmall: {
    '&&': {
      fontFamily: '"articulat-cf", sans-serif !important',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      width: '100%',
      gap: theme.spacing(1),
      fontSize: '13px',
      fontWeight: 600,
      lineHeight: '22px',
      letterSpacing: '0.02em',
      border: 'none !important',
      boxShadow: 'none !important',
      '@media (min-width: 900px) and (max-width: 1300px)': {
        '& .textForUpload': {
          display: 'none',
        },
      },
      '&.dragover': {
        backgroundColor: '#e3f2fd', 
        borderColor: '#42a5f5', 
      },
    },
  },
  input: {
    display: 'none',
  },
  addButton: {
    fontSize: '24px',
    fontWeight: 400,
    lineHeight: '24px',
    textAlign: 'center',
    cursor: 'pointer',
    color: '#3B4149',
    '&:hover': {
      color: '#1E88E5',
    },
  },
  seeAllButton: {
    '&&': {
      fontFamily: '"articulat-cf", sans-serif !important',
      background: '#FFF',
      color: '#3B4149',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: 'normal',
      textAlign: 'right',
      cursor: 'pointer',
      '&:hover': {
        color: '#1E88E5',
      },
      marginRight: '10px',
    },
  },
  dragAndDropBox: {
    
  }
}));

const AccountSummaryCollapse = ({
  accountSummaryData,
  collapse,
  handleNote,
  handleFile,
  refreshNotes,
  importFileForm,
  handleClick
}) => {
  const dispatch = useDispatch();
  const notes = useSelector((state) => state.accountNotes.accountNotesData);

  useEffect(() => {
    getNotes();
  }, [accountSummaryData, refreshNotes]);

  const getNotes = () => {
    if (Object.keys(accountSummaryData).length > 0) {
      dispatch(
        fetchAccountNotes({
          accountNumber: accountSummaryData.account,
          limit: 3,
          page: 1,
          orderDirection: '',
          orderBy: '',
          search: '',
          noteType: '',
          statusCode: '',
          creatorId: '',
          noteDate: '',
          notes: '',
          actionPerformed: '',
          changedFields: '',
        }),
      );
    } 
  };

  const classes = useStyles();

  const [isDragging, setIsDragging] = useState(false);
  const [hideFilePanel, setHideFilePanel] = useState(false);

  const handleDragOver = (event) => {
    setHideFilePanel(true);
    event.preventDefault();
    setIsDragging(true);
  };
  const handleDragLeave = () => {
    setHideFilePanel(false);
    setIsDragging(false);
  };
  const handleDrop = (event) => {
    event.preventDefault();
    setHideFilePanel(false);
    setIsDragging(false);
    handleFileChange(event);
  };

  const handleFileChange = (event) => {
    const file = event.dataTransfer ? event.dataTransfer.files[0] : event.target.files[0];

    if (file) {
      importFileForm(file);
    } else {
      importFileForm(null);
    }
    setHideFilePanel(false);
  };

  const [maxLength, setMaxLength] = useState(getMaxLength(window.innerWidth));
  useEffect(() => {
    function handleResize() {
      setMaxLength(getMaxLength(window.innerWidth));
    }

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  function getMaxLength(width) {
    if (width < 600) return 35;
    if (width >= 900 && width < 1240) return 25;
    if (width >= 1240 && width < 1550) return 35;
    if (width >= 1550 && width < 1640) return 45;
    return 55;
  }

  function truncateText(text, maxLength) {
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  }

  return (
    <div className="`row {classes.accordionSummaryCollapsed}`">
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={4}>
          {collapse ? (
            <Paper className={classes.paperItemsCollapsed}>
              <div className={classes.header}>
                <Typography className={classes.titleTabs}>Notes</Typography>
                <Typography sx={{ display: 'flex' }}>
                  <button
                    style={{ fontWeight: '700 !important' }}
                    className={classes.seeAllButton}
                    onClick={() => handleNote('seeAll')}
                  >
                    See All
                  </button>
                  <Typography className={classes.addCircleOutlineIcon}>
                    <AddCircleOutlineIcon
                      className={classes.addButton}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleNote('add');
                      }}
                    />
                  </Typography>
                </Typography>
              </div>
              <div className={classes.body}></div>
            </Paper>
          ) : (
            <Paper className={classes.paperItemsExpanded}>
              <div className={classes.header}>
                <Typography className={classes.titleTabs}>Notes</Typography>
                <Typography sx={{ display: 'flex' }}>
                  <button
                    style={{ fontWeight: '700 !important' }}
                    className={classes.seeAllButton}
                    onClick={() => handleNote('seeAll')}
                  >
                    See All
                  </button>
                  <Typography className={classes.addCircleOutlineIcon}>
                    <AddCircleOutlineIcon
                      className={classes.addButton}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleNote('add');
                      }}
                    />
                  </Typography>
                </Typography>
              </div>
              <div className={classes.body}>
                {notes && notes.length > 0 && (
                  <List className={classes.list}>
                    {notes.slice(0, 3).map((note, index) => (
                      <Tooltip
                        title={note.notes}
                        placement="top"
                        arrow
                        key={index}
                        slotProps={{
                          popper: {
                            modifiers: [
                              {
                                name: 'offset',
                                options: {
                                  offset: [0, -14],
                                },
                              },
                            ],
                          },
                        }}
                      >
                        <ListItem sx={{ padding: '0px', cursor: 'pointer' }}>
                          <ListItemIcon sx={{ color: '#3B4149',minWidth: '25px' }}>
                            <NotesIcon />
                          </ListItemIcon>
                          <ListItemText
                            classes={{ primary: classes.listItemTextFont }}
                            primary={truncateText(note.notes, maxLength)}
                          />
                        </ListItem>
                      </Tooltip>
                    ))}
                  </List>
                )}
              </div>
            </Paper>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <Input
            sx={{ display: 'none' }}
            accept="*/*"
            id="file-upload"
            type="file"
            onChange={handleFileChange}
            className={classes.input}
          />
          {collapse ? (
            <>
              { hideFilePanel ? (
                <div
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop}
                >
                  <Paper className={classes.paperItemsCollapsedDragged}>
                    <label
                      htmlFor="file-upload"
                      style={{ width: '100%', display: 'flex', alignItems: 'center' }}
                    >
                      <Paper 
                        className={`${classes.uploadAreaSmall} ${isDragging ? 'dragover' : ''}`}>
                        <UploadFileIcon style={{ color: '#1E88E5' }} />
                        Drop your files here to
                        <Typography
                          variant="body2"
                          style={{ color: '#1E88E5', textDecoration: 'underline', fontWeight:700, fontFamily: '"articulat-cf", sans-serif !important'}}
                        >
                          upload
                        </Typography>
                      </Paper>
                    </label>
                  </Paper>
                </div>
              ) : (
                <div
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop}
                >
                  <Paper className={classes.paperItemsCollapsed}>
                    <div className={classes.header}>
                      <Typography className={classes.titleTabs}>Files</Typography>
                      <label htmlFor="file-upload" style={{ display: 'flex', alignItems: 'center' }}>
                        <Paper className={classes.uploadAreaSmall}>
                          <UploadFileIcon style={{ color: '#1E88E5' }} />
                          <span className="textForUpload">Drop your files here to</span>
                          <Typography
                            variant="body2"
                            style={{ color: '#1E88E5', textDecoration: 'underline', fontWeight:700, fontFamily: '"articulat-cf", sans-serif !important'}}
                          >
                            upload
                          </Typography>
                        </Paper>
                      </label>
                      <Typography sx={{ display: 'flex' }}>
                        <button
                          style={{ fontWeight: '700 !important' }}
                          className={classes.seeAllButton}
                          onClick={() => handleFile('seeAll')}
                        >
                          See All
                        </button>
                        <Typography className={classes.addCircleOutlineIcon}>
                          <AddCircleOutlineIcon
                            className={classes.addButton}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleFile('add');
                            }}
                          />
                        </Typography>
                      </Typography>
                    </div>
                  </Paper>
                </div>
              )}
            </>
          ) : (
            <Paper className={classes.paperItemsExpanded}>
              <div className={classes.header}>
                <Typography className={classes.titleTabs}>Files</Typography>
                <Typography sx={{ display: 'flex', fontWeight: '700 !important' }}>
                  <button
                    style={{ fontWeight: '700 !important' }}
                    className={classes.seeAllButton}
                    onClick={() => handleFile('seeAll')}
                  >
                    See All
                  </button>
                  <Typography className={classes.addCircleOutlineIcon}>
                    <AddCircleOutlineIcon
                      className={classes.addButton}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleFile('add');
                      }}
                    />
                  </Typography>
                </Typography>
              </div>
              <div className={classes.body}>
                <div
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop}
                >
                  <label
                    htmlFor="file-upload"
                    style={{ width: '100%', display: 'flex', alignItems: 'center' }}
                  >
                    <Paper 
                      className={`${classes.uploadArea} ${isDragging ? 'dragover' : ''}`}>
                      <UploadFileIcon style={{ color: '#1E88E5' }} />
                      Drop your files here to
                      <Typography
                        variant="body2"
                        style={{ color: '#1E88E5', textDecoration: 'underline', fontWeight:700, fontFamily: '"articulat-cf", sans-serif !important'}}
                      >
                        upload
                      </Typography>
                    </Paper>
                  </label>
                </div>
              </div>
            </Paper>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          {collapse ? (
            <Paper className={classes.paperItemsCollapsed}>
              <div className={classes.header}>
                <Typography className={classes.titleTabs}>Account Alerts</Typography>
                <button style={{background:'#fff'}} onClick={handleClick}>
                  <Typography className={classes.warningIcon}>
                    {accountSummaryData.accountMessage ? accountSummaryData.accountMessage.length : 0}{' '}
                    <WarningIcon />
                  </Typography>
                </button>
              </div>
              <div className={classes.body}></div>
            </Paper>
          ) : (
            <Paper className={classes.paperItemsExpanded}>
              <div className={classes.header}>
                <Typography className={classes.titleTabs}>Account Alerts</Typography>
              </div>
              <div className={classes.body}>
                {accountSummaryData.accountMessage && accountSummaryData.accountMessage.length > 0 && (
                  <List className={classes.list}>
                    {accountSummaryData.accountMessage.map((message, index) => (
                      <ListItem key={index} sx={{ padding: '0px' }}>
                        <ListItemIcon sx={{ color: '#BA1A1A',minWidth: '25px' }}>
                          <WarningIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary={message}
                          classes={{ primary: classes.listItemTextFont }}
                        />
                      </ListItem>
                    ))}
                  </List>
                )}
              </div>
            </Paper>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default AccountSummaryCollapse;
